import React, { useState } from "react";
import Modal from "../generic/Modal";
import InputField from "../generic/InputField";
import SharedAlertBanner from "../shared/SharedAlertBanner";
import { validatePassword } from "../../utils/PasswordUtils";
import PasswordRequirements from "./PasswordRequirements";
import { Messages } from "../../constants/Messages";
import SubmitButton from "../generic/SubmitButton";

interface ResetPasswordModalProps {
    onClose: () => void; // Function to close the modal
    onSubmit: (password: string, confirmPassword: string) => Promise<any>; // Handle password reset submission
}

const ResetPasswordModal: React.FC<ResetPasswordModalProps> = ({ onClose, onSubmit }) => {
    const [ password, setPassword ] = useState<string>("");
    const [ confirmPassword, setConfirmPassword ] = useState<string>("");
    const [ errorMessage, setErrorMessage ] = useState<any>(null);
    const [ successMessage, setSuccessMessage ] = useState<any>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        // Validate password requirements
        const validationError = validatePassword(password);
        if (validationError) {
            return {
                message: validationError,
                success: false,
            };
        }

        if (password !== confirmPassword) {
            setErrorMessage(
                {
                    message: Messages.ERROR_PASSWORD_NOT_MATCH,
                });
            return;
        }

        const data = await onSubmit(password, confirmPassword);
        if (data.success) {
            setSuccessMessage({
                message: data.message,
            });
            setErrorMessage(null);
        } else {
            setErrorMessage({
                message: data.message,
            });
            setSuccessMessage(null);
        }
    };

    return (
        <Modal onClose={onClose}>
            <h2 className="text-lg font-semibold mb-4 text-center">Reset Password</h2>

            <SharedAlertBanner successAlert={successMessage}
                               errorAlert={errorMessage}
                               onCloseSuccess={() => setSuccessMessage(null)}
                               onCloseError={() => setErrorMessage(null)}
            />

            <form onSubmit={handleSubmit} className="space-y-4">
                <InputField
                    type="password"
                    value={password}
                    onChange={(value) => setPassword(value as string)}
                    label="New Password"
                    placeholder="Enter your new password"
                    required
                    id="new-password"
                />
                <PasswordRequirements password={password}/>
                <InputField
                    type="password"
                    value={confirmPassword}
                    onChange={(value) => setConfirmPassword(value as string)}
                    label="Confirm Password"
                    placeholder="Confirm your new password"
                    required
                    id="confirm-password"
                />
                <SubmitButton children={"Reset Password"}/>
            </form>
        </Modal>
    );
};

export default ResetPasswordModal;
